module.exports = __webpack_public_path__ + "img/dynamo_db.37575b52.jpg";